import { Quill } from 'react-quill';
import IframeBlot from './modules/IframeModule.js';
import TwitterBlot from './modules/TwitterModule.js';
import InstagramBlot from './modules/InstagramModule.js';
import FacebookLiveBlot from './modules/FacebookModule.js';

// Enregistre les blots seulement si ce n'est pas déjà fait
const registerBlots = () => {
  if (Quill && !Quill.registry) {
    Quill.register('formats/iframe', IframeBlot, true);
    Quill.register('formats/twitter', TwitterBlot, true);
    Quill.register('formats/instagram', InstagramBlot, true);
    Quill.register('formats/facebook', FacebookLiveBlot, true);
    
    // Marquer qu'on a déjà enregistré les blots pour ne pas le refaire
    Quill.registry = true;
  }
};

export default registerBlots;